export default __webpack_public_path__ + "static/media/ye.5bddd645.svg";